import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Nav from "@/components/landing/Nav";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";

const DEFAULT_TITLE = "Darlei Guia RJ | Guia de Turismo no Rio de Janeiro";

export default function LegalPage({ doc }) {
  useEffect(() => {
    document.title = `${doc.title} | Darlei Guia RJ`;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [doc]);

  return (
    <div data-testid={`legal-page-${doc.slug}`}>
      <Nav />
      <main className="mx-auto max-w-3xl px-5 pb-24 pt-36 sm:px-8 sm:pb-32">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-stone-400 transition-colors duration-300 hover:text-amber-400"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Voltar ao início
        </Link>
        <p className="mt-10 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
          Documento legal
        </p>
        <h1
          data-testid="legal-page-title"
          className="mt-4 font-display text-4xl font-extrabold leading-tight tracking-tight text-stone-50 sm:text-5xl"
        >
          {doc.title}
        </h1>
        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500">
          Última atualização: {doc.updated}
        </p>
        <p className="mt-8 text-base leading-relaxed text-stone-300 sm:text-lg">{doc.intro}</p>

        <div className="mt-12 space-y-10">
          {doc.sections.map((section) => (
            <section key={section.title}>
              <h2 className="font-display text-lg font-bold text-stone-50 md:text-xl">{section.title}</h2>
              <div className="mt-3 space-y-3">
                {section.paragraphs.map((p) => (
                  <p key={p} className="text-sm leading-relaxed text-stone-400 sm:text-base">
                    {p}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
